export default __webpack_public_path__ + "static/stanleyknife-b6a6a5738639f4226c7649610093d133.png";